import {
    get,
    isEqual
} from 'lodash';
import { SEARCH_UPDATE_INPUT } from './searchActions';
import { createSelector } from 'reselect';
import { getViewStateByName } from '../appViewStates';

export default function reducer(state = {}, action = {}) {
    let newState;

    switch (action.type) {
        case SEARCH_UPDATE_INPUT:
            newState = {
                ...state,
                inputValue: action.inputValue
            };

            return isEqual(state, newState) ? state : newState;

        default:
            return state;
    }
}

export const getSearchViewState = createSelector(
    (state) => state,
    (state) => getViewStateByName(state, 'search')
);

export const getInputValue = createSelector(
    getSearchViewState,
    (viewState) => get(viewState, 'inputValue')
);
